import React from 'react';

/**
 * Exports a higher-order component that connects the component to stores.
 * This higher-order component is most easily used as an ES7 decorator.
 * Decorators are just syntactic sugar over wrapping class in a function call.
 *
 * adapted from https://github.com/gaearon/flux-react-router-example
 */
export default function connectToStores(stores, getState) {
    return function (DecoratedComponent) {
        const displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

        return class StoreConnector extends React.Component {

            static displayName = `connectToStores(${displayName})`;

            state = getState(this.props) || {};

            static getDerivedStateFromProps(props) {
                return getState(props);
            }

            constructor(...args) {
                super(...args);

                stores.forEach((store) =>
                    store.addChangeListener(this._handleStoresChanged)
                );
            }

            componentWillUnmount() {
                stores.forEach((store) =>
                    store.removeChangeListener(this._handleStoresChanged)
                );
            }

            _handleStoresChanged = () => {
                this.setState(getState(this.props));
            };

            render() {
                return <DecoratedComponent { ...this.props } { ...this.state } />;
            }

        };
    };
}



// WEBPACK FOOTER //
// ./src/helpers/connectToStores.js